(function () {
    'use strict';
    angular.module('Services').service('TransitWarrantyClaimsTableService', TransitWarrantyClaimsTableService);
    TransitWarrantyClaimsTableService.$inject = [
        'TransitWarrantyService',
        'TableLiteFactory',
        'toastr',
        '$filter',
        '$uibModal',
        '$rootScope'
    ];

    function TransitWarrantyClaimsTableService(
        TransitWarrantyService,
        TableLiteFactory,
        toastr,
        $filter,
        $uibModal,
        $rootScope
    ) {
        return function (defaultFilters = {}) {
            const tableStructure = {
                tableName: 'TransitWarrantyClaimsTableService',
                config: {},
                headers: [
                    {
                        label: 'Created Date',
                        viewName: 'createdDateFormatted',
                        filterName: 'createdDate',
                        filter: {
                            type: 'datePicker',
                            url: '',
                            class: 'filter-date',
                            toModel: defaultFilters.createdDate ? new Date(defaultFilters.createdDate[0]) : '',
                            fromModel: defaultFilters.createdDate ? new Date(defaultFilters.createdDate[1]) : '',
                            useArray: true,
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Reference Number',
                        viewName: 'referenceNumberFormatted',
                        filterName: 'referenceNumber',
                        filter: {
                            type: 'text',
                            onSubmit: (header) => {
                                tableActions.sendRequest(tableActions.evaluateFilter(header))
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Consignment Number',
                        viewName: 'consignmentNumberFormatted',
                        filterName: 'consignmentNumber',
                        filter: {
                            type: 'text',
                            onSubmit: (header) => {
                                tableActions.sendRequest(tableActions.evaluateFilter(header))
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Carrier Profile',
                        viewName: 'carrierProfileNameFormatted',
                        filterName: 'carrierProfileName',
                        filter: {
                            type: 'text',
                            onSubmit: (header) => {
                                tableActions.sendRequest(tableActions.evaluateFilter(header))
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Customer Name',
                        viewName: 'customerNameFormatted',
                        filterName: 'customerName',
                        filter: {
                            type: 'text',
                            onSubmit: (header) => {
                                tableActions.sendRequest(tableActions.evaluateFilter(header))
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Declared Value',
                        viewName: 'declaredValueFormatted',
                        filterName: 'declaredValue',
                        filter: {
                            type: 'text',
                            onSubmit: (header) => {
                                tableActions.sendRequest(tableActions.evaluateFilter(header))
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Reason For Claim',
                        viewName: 'reasonForClaimFormatted',
                        filterName: 'reasonForClaim',
                        filter: {
                            type: 'text',
                            onSubmit: (header) => {
                                tableActions.sendRequest(tableActions.evaluateFilter(header))
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Claimed Amount',
                        viewName: 'claimAmountFormatted',
                        filterName: 'claimAmount',
                        filter: {
                            type: 'text',
                            onSubmit: (header) => {
                                tableActions.sendRequest(tableActions.evaluateFilter(header))
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Actions',
                        viewName: 'actions'
                    }
                ],
                data: []
            }

            const tableActions = new TableLiteFactory(tableStructure, {
                serviceCallback: TransitWarrantyService.Claims.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: error => {
                    buildTableData(null);
                    toastr.error(error);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc',
                    reseller_id: $rootScope.GlobalProfile.company.id
                }
            });

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                angular.forEach(data.content, row => {
                    row.referenceNumberFormatted = row.referenceNumber;
                    row.consignmentNumberFormatted = row.consignmentNumber;
                    row.carrierProfileNameFormatted = row.carrierProfileName;
                    row.customerNameFormatted = row.customerName;
                    row.declaredValueFormatted = row.declaredValue;
                    row.reasonForClaimFormatted = row.reasonForClaim;
                    row.claimAmountFormatted = row.claimAmount;
                    row.createdDateFormatted = $filter('date')(new Date(row.createdDate),"MM-dd-yyyy");
                    row.actions = {
                        type: 'button',
                        buttons: [
                            {
                                text: 'View',
                                class: 'btn-primary',
                                action: data => {
                                    showTransitWarrantyClaimsModal(angular.copy(data));
                                }
                            }
                        ]
                    };
                    tableStructure.data.push(row);
                });
            }

            function showTransitWarrantyClaimsModal(data) {
                const modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/pages/transit-warranty/modal/transit-warranty-claim-details-modal.html',
                    controller: 'TransitWarrantyClaimDetails',
                    controllerAs: 'vm',
                    size: 'md',
                    appendTo: $('body'),
                    resolve: {
                        shipment: () => null,
                        claimDetails: () => data
                    }
                });

                modalInstance.result.then(() => {
                    tableActions.sendRequest({});
                });
            }

            this.tableData = tableStructure;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/transit-warranty/TransitWarrantyClaimsTableService.js